const doc = [({"en":({"js":({"admin":({"orders":({"create_shipment_in_workplace_button":({"create_shipments_in_workplace":"Create shipments"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;